<template>
  <div class="search-container">
    <input
      class="search-input"
      placeholder="szukaj"
      v-model="search.phrase"
      v-on:keyup.enter="searchPhrase"
    />
    <span class="input-group-btn">
      <button class="btn btn-default" type="submit" @click="searchPhrase">
        <magnify-icon />
      </button>
    </span>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import BFormInput from "bootstrap-vue/esm/components/form-input/form-input";
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";

export default {
  components: { MagnifyIcon },
  computed: {
    ...mapState({
      search: state => state.search
    })
  },
  methods: {
    searchPhrase() {
      this.$store.dispatch("search/findByPhrase");
      this.$router.replace({ name: "searchPage" });
      console.log("searching...");
    }
    // keyDown(evt) {
    //   this.searchPhrase();
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/src/input/SearchInput.vue